var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.5291 8.27C17.4591 8.26 17.3891 8.26 17.3191 8.27C15.7691 8.22 14.5391 6.95 14.5391 5.39C14.5391 3.8 15.8291 2.5 17.4291 2.5C19.0191 2.5 20.3191 3.79 20.3191 5.39C20.3091 6.95 19.0791 8.22 17.5291 8.27Z",
    fill: "#314DDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.7896 15.1999C19.6696 15.9499 18.0996 16.2299 16.6496 16.0399C17.0296 15.2199 17.2296 14.3099 17.2396 13.3499C17.2396 12.3499 17.0196 11.3999 16.5996 10.5699C18.0796 10.3699 19.6496 10.6499 20.7796 11.3999C22.3596 12.4399 22.3596 14.1499 20.7896 15.1999Z",
    fill: "#314DDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.44039 8.27C6.51039 8.26 6.58039 8.26 6.65039 8.27C8.20039 8.22 9.43039 6.95 9.43039 5.39C9.43039 3.8 8.14039 2.5 6.54039 2.5C4.95039 2.5 3.65039 3.79 3.65039 5.39C3.66039 6.95 4.89039 8.22 6.44039 8.27Z",
    fill: "#314DDF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.54914 13.3501C6.54914 14.3201 6.75914 15.2401 7.13914 16.0701C5.72914 16.2201 4.25914 15.9201 3.17914 15.2101C1.59914 14.1601 1.59914 12.4501 3.17914 11.4001C4.24914 10.6801 5.75914 10.3901 7.17914 10.5501C6.76914 11.3901 6.54914 12.3401 6.54914 13.3501Z",
    fill: "#314DDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1208 16.37C12.0408 16.36 11.9508 16.36 11.8608 16.37C10.0208 16.31 8.55078 14.8 8.55078 12.94C8.55078 11.04 10.0808 9.5 11.9908 9.5C13.8908 9.5 15.4308 11.04 15.4308 12.94C15.4308 14.8 13.9708 16.31 12.1208 16.37Z",
    fill: "#314DDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87078 18.4401C7.36078 19.4501 7.36078 21.1101 8.87078 22.1101C10.5908 23.2601 13.4108 23.2601 15.1308 22.1101C16.6408 21.1001 16.6408 19.4401 15.1308 18.4401C13.4208 17.2901 10.6008 17.2901 8.87078 18.4401Z",
    fill: "#314DDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.d07643295ecbd4a9ec7ecaea3d91bc10.svg";
export { ForwardRef as ReactComponent };